import { render, staticRenderFns } from "./UiRestore.vue?vue&type=template&id=44888797&lang=pug&"
import script from "./UiRestore.vue?vue&type=script&lang=js&"
export * from "./UiRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports